// influencerOptions.ts

import { useGetLeadMarketinglookupQuery } from "../../../services/EndPointsApis";

type OptionsMappingType = {
    [key: string]: { value: string; label: string; }[];
};

type NestedOptionsMappingType = {
    [key: string]: { value: string; label: string; }[];
};

export const getMultiSelectLabels = () => {
    return new Set([
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
    ]);
};

export const getOptionsMapping = ({ getdefaultLookups }: any): OptionsMappingType => {
   

    if (!getdefaultLookups || !getdefaultLookups.result) {
        return {};
    }
    return {
        'Lst_DigitalBlast': getdefaultLookups.result.Lst_DigitalBlast?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
        'Lst_EventsExhibits': getdefaultLookups.result.Lst_EventExhibits?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
        'Lst_PrintedCirculation': getdefaultLookups.result.Lst_PrintedCirculation?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
        'Lst_ReferralProgram': getdefaultLookups.result.Lst_ReferralProgram?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
        'Lst_WebsiteThirdParty': getdefaultLookups.result.Lst_WebsiteThirdParty?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
        'Lst_WebsiteDirect': getdefaultLookups.result.Lst_WebsiteDirect?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
        'Lst_Signage': getdefaultLookups.result.Lst_signage?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
        'Lst_WebSocialMediaRoot': getdefaultLookups.result.Lst_WebSocialMediaRoot?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
        'Lst_WebSearchEngine': getdefaultLookups.result.Lst_WebSearchEngine?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
        'Lst_BroadcastNetwork': getdefaultLookups.result.Lst_BroadCast?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
    };
};

export const getNestedOptionsMapping = ({ getdefaultLookups }: any): NestedOptionsMappingType => {
    if (!getdefaultLookups || !getdefaultLookups.result) {
        return {};
    }
    return {
        'Web Social Media Network': getdefaultLookups.result.Lst_WebSocialMediaNetwork?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
        'Radio': getdefaultLookups.result.Lst_Radio?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
        'TV': getdefaultLookups.result.Lst_Tv?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
        'Search Engine Paid': getdefaultLookups.result.Lst_SearchEnginePaid?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
        'Web Search Engine Organic': getdefaultLookups.result.Lst_WebSearchEngineOrganic?.map((item: { id: any; value: any; }) => ({ value: String(item.id), label: item.value })) || [],
    };
};
export const getTargetOptions = () => {
    return [
        'Web Social Media Network',
        'Search Engine Paid',
        'Web Search Engine Organic',
        'Radio',
        'TV'
    ];
};
